import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M7.5 15a.4948.4948 0 0 1-.224-.053A.5008.5008 0 0 1 7 14.5v-9c0-.189.107-.363.276-.447s.372-.066.524.047l6 4.5c.126.094.2.243.2.4s-.074.306-.2.4l-6 4.5c-.088.066-.194.1-.3.1zM8 6.5v7l4.667-3.5L8 6.5z',
    'M19.5 2H.5c-.276 0-.5.224-.5.5v15c0 .276.224.5.5.5h19c.276 0 .5-.224.5-.5v-15c0-.276-.224-.5-.5-.5zM3 11H1V9h2v2zm0-3H1V6h2v2zm-2 4h2v2H1v-2zm3-9h12v14H4V3zm13 6h2v2h-2V9zm0-1V6h2v2h-2zm0 4h2v2h-2v-2zm2-7h-2V3h2v2zM3 3v2H1V3h2zM1 15h2v2H1v-2zm16 2v-2h2v2h-2z',
  ],
  height: 20,
  width: 20,
});
